export default {
  state: {
    pollTimer: {
      timerString: "0:00",
      count: 0
    },
    pollTimers: {}
  },
  mutations: {
    SOCKET_UPDATE_POLL_TIMER(state, payload) {
      state.pollTimer = payload;
      //console.log('S_TIMER', payload);
    }
  }
};
